import React from 'react';
import Card from './Card';
import CardHeader from './CardHeader';
import CardContent from './CardContent';
import CardActions from './CardActions';

export interface TableCardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  headerActions?: React.ReactNode;
  footerActions?: React.ReactNode;
  loading?: boolean;
  maxHeight?: string;
  className?: string;
  overflow?: 'hidden' | 'visible' | 'auto';
}

const TableCard: React.FC<TableCardProps> = ({
  title,
  subtitle,
  children,
  headerActions,
  footerActions,
  loading = false,
  maxHeight,
  className = '',
  overflow = 'hidden'
}) => {
  return (
    <Card
      variant="table"
      size="full"
      hover={false}
      loading={loading}
      className={className}
      overflow={overflow}
    >
      {/* Header */}
      {(title || subtitle || headerActions) && (
        <CardHeader title={title} subtitle={subtitle} actions={headerActions} border={true} />
      )}

      {/* Table Content */}
      <CardContent padding={false} scroll={true} maxHeight={maxHeight}>
        {children}
      </CardContent>

      {/* Footer Actions */}
      {footerActions && <CardActions border={true}>{footerActions}</CardActions>}
    </Card>
  );
};

export default TableCard;
